import { Component, Input } from '@angular/core'
import { IKeyword, ICustomer, IContentType } from '../../../graphql/queries/keyword.queries'
import moment from 'moment'
import 'moment-timezone'

@Component({
  selector: 'request-item',
  template: `
    <div class="row">
      <div class="col-8 d-flex flex-row flex-child-truncate justify-content-start align-items-center">
        <div class="text-truncate cursor-pointer"
          [class.strikethrough]="['deleted', 'fulfilled'].includes(keyword.state)"
          [routerLink]="['./', keyword.id, 'edit']">
          {{keyword.phrase}}
        </div>
        <div *ngIf="contentTypesEnabled">
          <span class="badge badge-tertiary badge-pill ml-2">
            {{keyword.contentType.name || 'eBook'}}
          </span>
        </div>
        <div *ngIf="keyword.queuedCount > 0"
          class="ml-2 d-flex cursor-pointer"
          [popover]="badgePopover"
          [routerLink]="['/dashboard', this.customer.id, 'submissions']"
          [queryParams]="{'search': this.keyword.id, 'group': 'queued', 'title': this.keyword.phrase}"
          triggers="mouseenter:mouseleave"
          container="body">
          <span class="badge badge-tertiary badge-pill"
            [class.badge-light]="!deadlinePassed(keyword.deadline)"
            [class.badge-danger]="deadlinePassed(keyword.deadline)">
            {{keyword.queuedCount}}
          </span>
          <i *ngIf="keyword.unaddressedCount > 0 || keyword.newCount > 0"
            class="notification"
            [class.text-success]="keyword.newCount > 0"
            [class.text-danger]="keyword.unaddressedCount > 0"></i>
          <ng-template #badgePopover>
            <span *ngIf="keyword.unaddressedCount > 0; else newOrQueued">
              <span *ngIf="deadlinePassed(keyword.deadline)">Overdue.</span>
              Writers have been waiting for your feedback for 1+ months.
            </span>
            <ng-template #newOrQueued>
              <span *ngIf="keyword.newCount > 0">
                <span *ngIf="deadlinePassed(keyword.deadline)">Overdue.</span>
                You have new submissions to review!
              </span>
              <span *ngIf="keyword.newCount === 0 && keyword.queuedCount > 0">
                <span *ngIf="deadlinePassed(keyword.deadline)">Overdue.</span>
                You have submissions that still need to be accepted or declined.
              </span>
            </ng-template>
          </ng-template>
        </div>
        <div *ngIf="keyword.awaitingEditingCount > 0 && keyword.queuedCount <= 0"
          class="ml-2 d-flex"
          [tooltip]="'You have submissions awaiting editing from writers.'">
          <span class="badge badge-outline badge-pill">
            {{keyword.awaitingEditingCount}}
          </span>
        </div>
      </div>
      <div class="col-4 d-flex justify-content-end">
        <request-details
          [contentTypesEnabled]="contentTypesEnabled"
          [keyword]="keyword"
          [ngClass]="{'d-flex flex-row text-nowrap justify-content-end align-items-center': true }"
        ></request-details>
        <request-buttons
          [keyword]="keyword"
          [customerId]="customerId"
          [customer]="customer"
          [contentTypes]="contentTypes"
        ></request-buttons>
      </div>
    </div>
  `
})
export class RequestItem {
  @Input() public customerId: number;
  @Input() public customer: ICustomer;
  @Input() public contentTypes: IContentType[];
  @Input() public contentTypesEnabled: boolean;
  @Input() public keyword: IKeyword;

  deadlinePassed(deadline: Date): boolean {
    return moment().isAfter(moment(deadline))
  }
}
